import { connect } from 'react-redux';
import SuburbField from './component';
import { suggestLocality } from '../../../../../actions/validation-service';

const mapDispatchToProps = {
  suggestLocality,
};

export default connect(null, mapDispatchToProps)(SuburbField);
